// removed by extract-text-webpack-plugin
module.exports = {"delayTimeWrapper":"delayTimeWrapper---30cxN"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/DelayTime/style.styl
// module id = I+r9
// module chunks = 89